import { ConsultsChart } from "./components/ConsultsChart";
import { ConsultSettings } from "./components/ConsultSettings";
import { TableConsults } from "./components/TableConsults";

export const Consultas = () => {
  return (
    <>
      <section className="flex flex-col gap-4 overflow-x-hidden 2xl:flex-row">
        <section className="hidden w-full rounded-3xl border border-gray01 p-5 sm:block">
          <ConsultsChart />
        </section>
        <section className="flex-grow rounded-2xl border border-border p-5 sm:min-w-[465px]">
          <ConsultSettings />
        </section>
      </section>
      <section className="relative mt-6">
        <TableConsults />
      </section>
    </>
  );
};
